import React from "react";
import { Card, CardTitle, CardText } from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import { connect } from "react-redux";
import { GridList, GridTile } from "material-ui/GridList";
import { Link } from "react-router";
import { fetchOwnResponses } from "../actions/responses";
import FisheryStatusModal from "../components/FisheryStatusModal";
import { calculateResults } from "../reducer/response";
import { createNewResponse } from "../actions/responseMetadata";
import { pushResponseIfNeeded } from "../actions/sync";
import HomeHeaderBar from "../containers/HomeHeaderBar";
import { withRouter } from "react-router";
import FisheryMetadataDialog from "../components/FisheryMetadataDialog";
import FeedbackDialog from "../components/FeedbackDialog";
import { sendFeedback } from "../actions/feedback";
import UserResponseList from "../components/UserResponseList";
import { updateFisheryMetadata } from "../actions/response";
import {dlQInOrder} from '../Reports/AdminExports';
import { updateTrForResponse } from '../actions/translation';
import { DropDownMenu, MenuItem } from "material-ui";
import {fetchTranslation} from '../actions/translation';
//import questionnaireFilters from "../reducer/questionnaireFilters";

const titleStyle = {};

const styles = {
  gridList: {
    width: 750,
    height: 200,
    overflowY: "hidden"
  },
  gridTile: {
    cursor: "pointer"
  }
};

class UserHomepageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newFisheryPromptOpen: false,
      openResponseId: null,
      isNew: false,
      feedbackDialogOpen: false,
      metadataOpen: false,
      trID:-1,
      trIDForDownload:-1
    };
  }

  componentDidMount = () => {
    if (!this.props.loggedIn && this.props.authError) {
      this.props.router.push("/");
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.responseID !== nextProps.responseID ||
      (this.props.responseID && !this.state.openResponseId)
    ) {

      this.setState({
        openResponseId: nextProps.responseID
      });
    } else if (!nextProps.responseID) {
      this.setState({ openResponse: null });
    }
    if (!nextProps.loggedIn) {
      this.props.router.push("/");
    }
  };

  handleNewFisheryClose = () => {
    this.setState({ newFisheryPromptOpen: false });
    if (this.props.new) {
      this.props.router.push("/home");
    }
  };

  handleNewFisheryOpen = () => {
    this.setState({ newFisheryPromptOpen: true });
  };

  render() {
    let props = this.props;
    let text = false;
    if (props.fetching && !props.responses.length) {
      text = "Retrieving your responses...";
    } else if (props.responses.length === 0) {
      text =
        "You have no fisheries in your account. Add one to start using FishPath.";
    }
    let buttonStyle = {
      position: "relative",
      top: props.responses.length || props.fetching ? 0 : -35,
      marginLeft: props.responses.length ? 15 : 0
    };
    return (
      <div>
        <HomeHeaderBar />
        <Card style={{ maxWidth: 800, margin: "80px auto" }}>
          <CardTitle titleStyle={{fontSize:32, textAlign:'center'}} title="FishPath Tool Dashboard" />
          <CardText>
            Welcome to your FishPath Tool Dashboard. Here, you may view the
            "FishPath Tool User Guide". Your existing FishPath Tool fishery
            questionnaires and results are found under "My Fisheries". New
            fisheries may be added using the "Add a Fishery" button. Below,
            you may access the full list of options and resources contained
            within the FishPath Tool under "Reference Materials". You may also
            access these same materials through the top left menu.
          </CardText>
          <CardTitle title="FishPath Tool User Guide" />
          <CardText>
            The <a target="_blank" rel="noopener noreferrer" href="https://fishpath.github.io/FishPath-Tool-User-Guide/">FishPath Tool User Guide</a> contains
            detail on using the FishPath Tool and interpreting results. It also contains
            a <a target="_blank" rel="noopener noreferrer" href="https://fishpath.github.io/FishPath-Tool-User-Guide/glossary.html">Glossary</a> of
            fisheries terms which are linked to directly throughout the questionnaire.
          </CardText>
          
          <CardTitle title="My Fisheries" />
          <CardText>
            <RaisedButton
              style={buttonStyle}
              label="Create New Fishery"
              primary={true}
              onClick={this.handleNewFisheryOpen}
            />
          </CardText>
          {text ? <CardText>{text}</CardText> : ""}
          <UserResponseList onClick={this.handleFisheryClick} limit={5} />
          
          <hr/>
          <CardTitle
            title="Harvest Strategy Support Page"
          />
          <CardText>
            <div>
            As you complete each of the 3 sections in the FishPath Tool (data collection, stock assessment, management measures) for your fishery,
             this page will be populated with the lists of top options for each section. You can visualize these top options and their linkages,
             as well as access resources and examples to support harvest strategy development.
            <br/>
            
            </div>
            <figure style={{maxWidth: 750, margin: "20px auto"}}>
              <img src="/hs_diagram.png?v=2" alt="" style={{objectFit: 'fill', maxWidth: 750}}/>
              <figcaption>Simplified concept of linking the 3 sections within the FishPath Tool. Visit the Harvest Strategy Development Support Page for more resources.</figcaption>
            </figure>
            <br/>
            <RaisedButton 
              style={buttonStyle}
              label="Harvest Strategy Resource Page"
              primary={false}
              containerElement={
                <Link to={`/questionnaire/reference/harvestStrategy`} />
              }
            />
          </CardText>
          <hr/>
          <CardTitle
            title="Reference Materials"
            subtitle="Options within the FishPath Tool are divided into the 3 sections below."
          />
          <CardText>
            <GridList cellHeight={180} style={styles.gridList} cols={3}>
              <GridTile
                className="sectionGridTile"
                key="monitoring"
                title="Data Collection"
                titleStyle={titleStyle}
                style={styles.gridTile}
                containerElement={
                  <Link to="/questionnaire/reference/monitoring" />
                }
              >
                <img src="/monitoring.png?v=2" alt="" />
              </GridTile>
              <GridTile
                className="sectionGridTile"
                key="assessment"
                title="Assessment"
                titleStyle={titleStyle}
                style={styles.gridTile}
                containerElement={
                  <Link to="/questionnaire/reference/assessment" />
                }
              >
                <img src="/assessment.png?v=2" alt="" />
              </GridTile>
              <GridTile
                className="sectionGridTile"
                key="decisionRules"
                title="Management Measures"
                titleStyle={titleStyle}
                titleBackground="transparent"
                titlePosition="bottom"
                style={styles.gridTile}
                containerElement={
                  <Link to="/questionnaire/reference/controlRules" />
                }
              >
                <img src="/decisionrules.png?v=2" alt="" />
              </GridTile>
            </GridList>
            <br />
          </CardText>
          <CardText>
            <RaisedButton
              style={buttonStyle}
              label="Download Question List"
              primary={false}
              onClick={this.downloadQuestionList}
            />
            {/* <DropDownMenu
              style={{...buttonStyle, top: 20, width: 200}}
              value={this.state.trIDForDownload}
              onChange={this.onTrDownloadDropDownMenuChange.bind(this)}
            >
              <MenuItem value={-1} primaryText="English" />
              {this.props.translationList.map(lang => <MenuItem key={lang.id} value={lang.id} primaryText={lang.title} />)}

              </DropDownMenu> */}
          </CardText>
          <FisheryMetadataDialog
            modal={false}
            isNew={true}
            onRequestClose={this.handleNewFisheryClose}
            open={this.state.newFisheryPromptOpen || this.props.new}
            handleSave={this.handleCreateFishery}
          />
          { this.state.metadataOpen && <FisheryMetadataDialog
            modal={false}
            isNew={false}
            onRequestClose={() => this.setState({ metadataOpen: false })}
            open={!!this.state.metadataOpen}
            metadata={this.state.metadataOpen}
            handleSave={this.handleMetadataUpdate}
          />}
          { this.state.openResponseId && <FisheryStatusModal
            calculateResults={response =>
              calculateResults(
                props.questions,
                response.answers,
                props.options,
                props.categories,
                props.tags
              )
            }
            responseId={this.state.openResponseId}
            isNew={this.state.isNew}
            open={!!this.state.openResponseId}
            readOnly={this.props.responses.find((r) => r.metadata.id === this.state.openResponseId).email !== props.email && !props.isAdmin}
            onRequestClose={this.closeStatusModal}
            onRequestEditMetadata={() => {
              this.setState({
                metadataOpen: this.props.responses.find((r) => r.metadata.id === this.state.openResponseId),
                openResponseId: false
              });
            }}
            trID={this.props.responses.find((r) => r.metadata.id === this.state.openResponseId).userEdits.trIDForResponse}
            translationList={this.props.translationList}
            onTrDropDownMenuChange={this.onDropDownMenuChange.bind(this)}
          />}
          <CardTitle
            title="Get Support, Ask a Question, or Help us Improve the FishPath Tool"
          />
          <CardText>
            <div style={{marginBottom:15}}>
              Please reach out to our team if there is a software issue or the <a target="_blank" rel="noopener noreferrer" href='https://fishpath.github.io/FishPath-Tool-User-Guide/'>User Guide</a> does
               not cover your question. We will reply within 1 week. We also welcome your comments and suggestions towards improving the Tool. Our goal
              is to continually improve and expand upon the content and functionality of the FishPath Tool.
            </div>
            <RaisedButton
              label="Send Feedback"
              primary={false}
              onClick={() => this.setState({ feedbackDialogOpen: true })}
              style={{marginLeft:15}}
            />
          </CardText>
        </Card>
        <FeedbackDialog
          open={this.state.feedbackDialogOpen}
          handleSubmit={this.props.sendFeedback}
          handleClose={() => this.setState({ feedbackDialogOpen: false })}
        />
      </div>
    );
  }


  handleMetadataUpdate = (attrs) => {
    this.props.handleFisheryMetadataSave(attrs, this.state.metadataOpen.metadata.id);
    this.setState({metadataOpen: false});
  }

  closeStatusModal = () => {
    this.props.router.push("/home");
  };

  handleCreateFishery = attrs => {
    this.props.createFishery(attrs, response => {
      this.setState({ newFisheryPromptOpen: false });
      this.handleFisheryClick(response);
    });
  };

  handleFisheryClick = response => {
    // console.log("response", response);
    // this.setState({ metadataOpen: response });
    this.props.router.push("/home/"+response.metadata.id);
  };

  downloadQuestionList = () => {
    let translation = this.props.translations.find(t => t.id === this.state.trIDForDownload)
    
    var cols = ["Question Order", "Question", "Description", "Category", "Answers", "All Sections For Question"];
    var sections = ["monitoring", "assessment", "controlRules"];
    var description = "Some questions appear in multiple sections in the FishPath Tool online questionnaire. " +
      "A question that has already been answered in another section will not appear again later in the questionnaire. " +
      "In this report each question will appear in all sections that it is included in. Use the 'All Sections for Question' "+
      "column to see each section that the question could be asked in.";
    dlQInOrder(cols, sections, description, translation);
  }

  onTrDownloadDropDownMenuChange = (event, index, value) => {
    this.setState({
      trIDForDownload: value
    })
    //load the translation if it is not already
    if(!this.props.translations.find(t => t.id === value)){
      this.props.fetchTranslation(value)
    }
  }

  onDropDownMenuChange = (event, index, value) => {
    this.setState({
      trID: value
    })
    this.props.handleTrChangeForResponse(value, this.state.openResponseId)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    responses: state.responses.items
      .sort((a, b) => a.metadata.createdAt - b.metadata.createdAt)
      .reverse(),
    loggedIn: !!state.auth.token,
    fetching: state.responses.fetching,
    questions: state.questions,
    categories: state.categories,
    options: state.options,
    new: [...window.location.pathname.split("/")].pop() === "new",
    responseID: ownProps.routeParams.id,
    authError: state.auth.error,
    tags: state.tags,
    email: state.auth.email,
    isAdmin: state.auth.isAdmin,
    translationList: state.translationList.filter(tr => tr.published),
    translations: state.translations
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchOwnResponses: callback => dispatch(fetchOwnResponses(callback)),
    createFishery: (name, callback) => {
      dispatch(createNewResponse(name, callback));
      dispatch(pushResponseIfNeeded());
    },
    sendFeedback: (opts, callback) => dispatch(sendFeedback(opts, callback)),
    handleFisheryMetadataSave: (attrs, id) => dispatch(updateFisheryMetadata(attrs, id)),
    handleTrChangeForResponse: (trID, responseID) => dispatch(updateTrForResponse(trID, responseID)),
    fetchTranslation: (id) => dispatch(fetchTranslation(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserHomepageContainer));
